import React from 'react';

import Image, { TRANSFORMATIONS } from 'components/uiLibrary/Image';

import { COMPONENTS } from 'components/Globals/Analytics/constants';
import VideoCard from 'components/Media/Display/VideoCard';

import { getMediaSource } from 'utils/media';
import { useQuery } from 'utils/react-query';

import queries from 'containers/Media/queries';

import { ENTITY_TYPES } from 'operabase-router/constants';

import classes from './MediaList.module.scss';
import Poster from './Poster';

const MediaList = ({ production, trackingData, showLightbox, hidePoster }) => {
  const hasPhotos = production?.imageCount > 0 || production?.stats?.media?.images?.exists;
  const hasVideos = production?.videoCount > 0 || production?.stats?.media?.videos?.exists;

  const { data: photosData } = useQuery(
    queries.getFeaturedPhotos({
      entityId: production?.id,
      entityType: ENTITY_TYPES.PRODUCTION,
      queryConfig: { enabled: hasPhotos },
    }),
  );

  const { data: videosData } = useQuery(
    queries.getFeaturedVideos({
      entityId: production.id,
      entityType: ENTITY_TYPES.PRODUCTION,
      queryConfig: { enabled: hasVideos },
    }),
  );

  const { data: videos } = videosData || {};
  const { data: photos } = photosData || {};

  const completeTrackingData = {
    ...trackingData,
    component: COMPONENTS.PHOTOS,
  };

  const openLightbox = mediaId => {
    showLightbox({ data: photos, mediaId, trackingData: completeTrackingData });
  };

  if (!production?.poster?.id && !hasVideos && !hasPhotos) {
    return null;
  }

  return (
    <div
      className={classes.mediaList}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Poster production={production} styles={{ poster: classes.poster }} hidePoster={hidePoster} />
      {videos?.map((video, index) => (
        <VideoCard
          data={video}
          hideVideoInfoForce
          styles={{ root: classes.videoCard, videoPlayerRoot: classes.videoPlayerRoot }}
          width={138}
          height={78}
          key={index}
        />
      ))}
      <div className={classes.mediaList__photos}>
        {photos?.map((photo, index) => (
          <Image
            key={index}
            src={getMediaSource(photo, true)}
            blurHash={photo?.blurHash || photo?.file?.urls?.blurHash}
            width={138}
            height={76}
            transformations={TRANSFORMATIONS.SLUG_MEDIA}
            onClick={() => openLightbox(photo?.id)}
            trackingData={completeTrackingData}
            disableNextImage
            useIntersectionObserver
            lazy
          />
        ))}
      </div>
    </div>
  );
};

export default MediaList;
